import api from './index'
import { marketplaceData } from '../assets/fake-data/data-marketplace'

const itemService = {
    // List all items
    getItems: async () => {
        try {
            const res = await api.get('/api/v1/items')

            if (res.data.success) {
                return { data: res.data.data }
            } else {
                console.error('API call was not successful:', res.data.message)
                return { error: res.data.message }
            }
        } catch (error) {
            console.error('API call failed:', error)
            return { error: 'Failed to fetch items' }
        }
    },
    // Get item by ID
    getItemById: (id) => api.get(`/items/${id}`),

    // Create a new item
    createItem: (data) => api.post('/items', data),

    // Update an existing item
    updateItem: (id, data) => api.put(`/items/${id}`, data),

    // Delete an item
    deleteItem: (id) => api.delete(`/items/${id}`),

    // Filter items based on query parameters
    filterItems: (query) => api.get('/items', { params: query }),
}

export default itemService
